module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/mf-c02a78fb2738ceb5eece24c60cb245f5.svg";